import React, { useState, useEffect } from 'react';
import './index.scss';
import EmailOtpFlow from './EmailOtpFlow';
import MateAppFlow from '../../Components/Login/MateAppFlow';
import MainScreen from '../../Components/Login/MainScreen';

type LoginFlow = 'main' | 'email_otp' | 'mate_app';

const LoginPage: React.FC = () => {
    const [currentFlow, setCurrentFlow] = useState<LoginFlow>('main');
    const [redirectTo, setRedirectTo] = useState(new URLSearchParams(window.location.search).get('redirectTo') ?? '/');
    const [urlParams, setUrlParams] = useState<{
        email?: string;
        userid?: string;
        otp?: string;
        autoVerify?: boolean;
    }>({});

    useEffect(() => {
        const queryParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());
        
        const { otp, email, userid, redirectTo: redirect } = queryParams;
        
        // Store URL parameters
        const params = {
            email: email || '',
            userid: userid || '',
            otp: otp || '',
            autoVerify: !!(otp && (email || userid))
        };
        setUrlParams(params);
        
        // Handle redirect URL
        if (redirect) {
            try {
                const url = new URL(redirect, window.location.origin);
                if (url.origin === window.location.origin || redirect.startsWith('/')) {
                    setRedirectTo(redirect);
                }
            } catch (e) {
                console.error('Invalid redirect URL', e);
            }
        }
        
        // Determine initial flow based on URL parameters
        if (otp) {
            setCurrentFlow('email_otp'); // Go to OTP step
        } else if (email || userid) {
            setCurrentFlow('email_otp'); // Go to email step
        }
    }, []);

    const handleLoginSuccess = () => {
        // Redirect after successful login
        window.location.href = redirectTo;
    };

    const handleBackToMain = () => {
        setCurrentFlow('main');
    };


    if (currentFlow === 'email_otp') {
        return (
            <EmailOtpFlow
                onSuccess={handleLoginSuccess}
                onBack={urlParams.email || urlParams.userid ? undefined : handleBackToMain}
                initialEmail={urlParams.email}
                initialUserid={urlParams.userid}
                initialOtp={urlParams.otp}
                autoVerify={urlParams.autoVerify}
                showBackButton={!(urlParams.email || urlParams.userid)}
            />
        );
    }

    if (currentFlow === 'mate_app') {
        return (
            <MateAppFlow
                onSuccess={handleLoginSuccess}
                onBack={handleBackToMain}
                showBackButton={true}
            />
        );
    }

    return (
        <MainScreen 
            onMateSignin={() => setCurrentFlow('mate_app')}
            onEmailSignin={() => setCurrentFlow('email_otp')}
        />
    );
};

const LoginPageWrapper = () => {
    return (
        <div className="login-page">
            <img src="/logo-white.svg" alt="Korean Mate Logo" className="logo" />
            <div className="login-container">

                <div className="login-form">
                    <LoginPage/>
                </div>
                
                <div className="login-footer">
                    <p>
                        {'By continuing, you agree to our '}
                        <a href="/termsofuse" target="_blank" rel="noopener noreferrer">
                            {"Terms of Use"}
                        </a>{' '}
                        {'and '}
                        <a href="/privacypolicy" target="_blank" rel="noopener noreferrer">
                            {"Privacy Policy"}
                        </a>
                        {"."}
                    </p>
                </div>
            </div>
            <img src="/logo-white.svg" alt="Korean Mate Logo" className="logo invisible" />
        </div>
    );
};

export default LoginPageWrapper;